export function readPageResponse(response) {
  if (response?.success !== true) throw new Error('LIST_READ_FAILED');
  const rows = response.data?.list ?? response.data?.records;
  const rawTotal = response.data?.total;
  const total = typeof rawTotal === 'string' && /^(0|[1-9]\d*)$/.test(rawTotal) ? Number(rawTotal) : rawTotal;
  if (!Array.isArray(rows) || !Number.isSafeInteger(total) || total < 0 || total < rows.length) {
    throw new Error('INVALID_PAGE_RESPONSE');
  }
  return { success: true, message: response.message, total, data: rows };
}
